import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class TrueOrFalseProps {
  @Inlet(Accepts.Image) public image?: Types["Image"];

  @Inlet(Accepts.ImageFilter) public imageFilter?: Types["ImageFilter"];

  @Inlet(Accepts.MarkdownText) public question?: Types["MarkdownText"];
  @Inlet(Accepts.TrueOrFalse) public answer?: Types["TrueOrFalse"];

  @Inlet(Accepts.Void) public logic?: Types["Void"];
}

export const TrueOrFalseDefinition = defineElement(
  "true-or-false",
  TrueOrFalseProps,
  {
    versionRequired: "0.38.0",
  }
);

export const TRUE_OR_FALSE_ACTIONS = {
  onTrueSelected: "on-true-selected",
  onFalseSelected: "on-false-selected",
};
